import Image from "next/image";

const HeroSectionComponent = (props) => {

  return (
    <>
      <div className="mb-3 mds-bg-primary-muted">
        <div className="container mt-4">
          <div
            className="d-flex justify-content-between align-items-center flex-column-reverse flex-lg-row pb-3 pb-lg-5 gap-3 gap-lg-5">
            <div className="mds-text-primary-dark">
              <h1 className="text-capitalize m-0 mb-1">{props.title}</h1>
              <p
                className="mds-fs-p m-0 mds-text-secondary">
                {props.description}
              </p>
              {props.PrimaryComponent &&
                <div className="mt-4">
                  <props.PrimaryComponent />
                </div>
              }
            </div>
            <div>
            {props.image && 
            <Image
                layout="fixed"
                src={props.image}
                alt={props.title}
                width={300}
                height={300}
              />
            }
            </div>
          </div>
        </div>
      </div>

    </>
  );
}

export default HeroSectionComponent;
